<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 financeTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="finance"
                        arrows >
                    <template slot="gofixTab:finance">
                        <gofix-card title=" " class="financeInfoCard">
                            <template slot="gofixCard:right_header">
                                <button class="icon-button" @click="openEditFinanceInfo"><img width="20" src="img/iconPencil.png" alt="" /></button>
                            </template>
                            <b-row>
                                <b-col md="3">
                                    <div class="d-flex field-display-basic">
                                        <span class="label">Client Name</span>
                                        <span class="value">{{ ClientContractID && ClientContractID.client && ClientContractID.client.name ? ClientContractID.client.name : '--' }}</span>
                                    </div>
                                </b-col>
                                <b-col md="3">
                                    <div class="d-flex field-display-basic">
                                        <span class="label">FM Company</span>
                                        <span class="value">{{ ClientContractID && ClientContractID.supplier && ClientContractID.supplier.name ? ClientContractID.supplier.name : '--' }}</span>
                                    </div>
                                </b-col>
                                <b-col md="3">
                                    <div class="d-flex field-display-basic">
                                        <span class="label">Finance Company</span>
                                        <span class="value">{{ ClientContractID && ClientContractID.finance_company && ClientContractID.finance_company.company ? ClientContractID.finance_company.company.name : '--' }}</span>
                                    </div>
                                </b-col>
                                <b-col md="3">
                                    <div class="d-flex field-display-basic">
                                        <span class="label">Bank GL Code</span>
                                        <span class="value">{{ ClientContractID && ClientContractID.bank_gl_code ?  ClientContractID.bank_gl_code.bank_gl_code : '--' }}</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card title="Head Lease" fullContent>
                            <head-lease></head-lease>
                        </gofix-card>
                        <gofix-card title="Department Code & Debtor Code" fullContent>
                            <department-code></department-code>
                        </gofix-card>
                        <gofix-card title="FM Codes" fullContent >
                            <fm-code></fm-code>
                        </gofix-card>
                       <!--  <gofix-card title="Navision Setting" fullContent class="mb-0">
                            <navision-setting></navision-setting>
                        </gofix-card> -->
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-WorkOrder" title="Edit Finance Info" hide-footer :centered="true" v-model="models.finance.open">
            <b-form class="formV2">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input label="Bank GL code" v-model="models.finance.data.bank_gl_code"></gofix-form-input>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Finance Company"
                                vLabel="name"
                                v-model="models.finance.data.finance_company"
                                :options="models.finance.financeCompanies">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="SUBMIT" @click="saveContractFinanceInfo" :loading="models.finance.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import tabData from '@/data/_tabs';
    import { filters } from '@/_filterVar.js';
    const fmCode = () => import("./fm-code")
    const departmentCode = () => import("./department-code")
    const headLease = () => import("./head-lease")
    // import NavisionSetting from "./navision-setting"
    export default {
        name: 'fm-codes',
        components: {
            fmCode,
            departmentCode,
            headLease,
            // NavisionSetting
        },
        data () {
            let filterFmcode = JSON.parse(JSON.stringify(filters['fm_codes']));
            return {
                contract_tab:tabData.client_contract,
                models:{
                    finance:{
                        open:false,
                        loading:false,
                        data:{
                            bank_gl_code: null,
                            finance_company: null,
                        },
                        financeCompanies: []
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        created() {
            this.getFinanceCompanies();
        },
        methods:{
            /*--------------------- Get data------------------*/
            getFinanceCompanies(){
                this.$store.dispatch("ChartOfAccountController/getCompanies", {
                    limit: -1,
                    page: 1
                })
                    .then(response => {
                        this.models.finance.financeCompanies = response.items;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },

            /*--------------------- Save data------------------*/
            saveContractFinanceInfo(){
                if(this.models.finance.loading) return ;
                if (!this.models.finance.data.bank_gl_code) {
                    return this.$alertNotification("Department/BU Code is a required field", "danger");
                }
                if (!this.models.finance.data.finance_company) {
                    return this.$alertNotification("Please select a finance company", "danger");
                }

                let data         = Object.assign({}, this.ClientContractID);
                data.update_bank_gl_code = this.models.finance.data.bank_gl_code;
                data.finance_company =  this.models.finance.data.finance_company;
                data.update_finance_company_id =  this.models.finance.data.finance_company ? this.models.finance.data.finance_company.id : null;
                data.contract_id = this.ClientContractID.id;
                data.settings = JSON.stringify(data.settings);
                data.case_settings = JSON.stringify(data.case_settings);
                
                delete data.contract_terms;
                delete data.terms_option;
                delete data.terms_base;
                delete data.extra_info;
                delete data.contract_variation_info;
                delete data.extension_period_main;
                delete data.extention_period;

                this.models.finance.loading = true;
                this.$store.dispatch('ContractController/UpdateClientContract', data)
                    .then(result => {
                        this.models.finance.loading = false;
                        this.models.finance.open = false;

                        this.ClientContractID.bank_gl_code = result.data.data.data.bank_gl_code;
                        this.ClientContractID.finance_company = result.data.data.data.finance_company ;

                        return this.$alertNotification(this.$notificationV2('editing', 'fm_code_finance'));
                    })
                    .catch(error => {
                        console.log(error);
                        this.models.finance.loading = false;
                        if(error.response) {
                            if(error.response.data.error.message.error) {
                                return this.$alertNotification(error.response.data.error.message.error, "danger");
                            }
                            this.$alertNotification("Error", "danger");
                        }
                    })
            },

            /*--------------------- Models ------------------*/
            openEditFinanceInfo(){
                this.models.finance.open = true;
                this.models.finance.data.bank_gl_code = this.ClientContractID.bank_gl_code ? this.ClientContractID.bank_gl_code.bank_gl_code : null;
                this.models.finance.data.finance_company = this.ClientContractID.finance_company ? this.ClientContractID.finance_company.company : null;
            }
        }
    }
</script>